export const config = {
  app: {
    name: import.meta.env.VITE_APP_NAME || 'BAS & More',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    env: import.meta.env.VITE_APP_ENV || 'development',
  },
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.absee.biz/api',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000', 10),
  },
  auth: {
    enabled: import.meta.env.VITE_AUTH_ENABLED === 'true',
    sessionTimeout: parseInt(import.meta.env.VITE_SESSION_TIMEOUT || '3600000', 10),
  },
  tenant: {
    isolationEnabled: import.meta.env.VITE_TENANT_ISOLATION_ENABLED === 'true',
    defaultTenantId: import.meta.env.VITE_DEFAULT_TENANT_ID || 'default',
  },
  ai: {
    enabled: import.meta.env.VITE_OPENAI_API_ENABLED === 'true',
    mlPredictionsEnabled: import.meta.env.VITE_ML_PREDICTIONS_ENABLED === 'true',
    confidenceThreshold: parseFloat(import.meta.env.VITE_AI_CONFIDENCE_THRESHOLD || '0.85'),
  },
  integrations: {
    xero: {
      enabled: import.meta.env.VITE_XERO_ENABLED === 'true',
      clientId: import.meta.env.VITE_XERO_CLIENT_ID || '',
    },
    sharepoint: {
      enabled: import.meta.env.VITE_SHAREPOINT_ENABLED === 'true',
      tenantId: import.meta.env.VITE_SHAREPOINT_TENANT_ID || '',
      clientId: import.meta.env.VITE_SHAREPOINT_CLIENT_ID || '',
    },
    voiceAI: {
      enabled: import.meta.env.VITE_VOICE_AI_ENABLED === 'true',
      provider: import.meta.env.VITE_SPEECH_TO_TEXT_PROVIDER || 'openai',
    },
  },
  biometrics: {
    enabled: import.meta.env.VITE_BIOMETRIC_AUTH_ENABLED === 'true',
    facial: import.meta.env.VITE_FACIAL_RECOGNITION_ENABLED === 'true',
    voice: import.meta.env.VITE_VOICE_BIOMETRIC_ENABLED === 'true',
  },
  storage: {
    provider: import.meta.env.VITE_STORAGE_PROVIDER || 'spark-kv',
    cloudEnabled: import.meta.env.VITE_CLOUD_STORAGE_ENABLED === 'true',
  },
  monitoring: {
    sentry: {
      enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
      dsn: import.meta.env.VITE_SENTRY_DSN || '',
    },
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
    analyticsEnabled: import.meta.env.VITE_ANALYTICS_ENABLED === 'true',
  },
  features: {
    workflowAutomation: import.meta.env.VITE_FEATURE_WORKFLOW_AUTOMATION === 'true',
    rpaAgents: import.meta.env.VITE_FEATURE_RPA_AGENTS === 'true',
    aiEmailDrafting: import.meta.env.VITE_FEATURE_AI_EMAIL_DRAFTING === 'true',
    voiceAI: import.meta.env.VITE_FEATURE_VOICE_AI === 'true',
    biometricAuth: import.meta.env.VITE_FEATURE_BIOMETRIC_AUTH === 'true',
    predictiveAnalytics: import.meta.env.VITE_FEATURE_PREDICTIVE_ANALYTICS === 'true',
    abTesting: import.meta.env.VITE_FEATURE_AB_TESTING === 'true',
    revenueForecast: import.meta.env.VITE_FEATURE_REVENUE_FORECASTING === 'true',
    coa: import.meta.env.VITE_FEATURE_COA === 'true',
  },
  compliance: {
    auditLogging: import.meta.env.VITE_AUDIT_LOGGING_ENABLED === 'true',
    gdprMode: import.meta.env.VITE_GDPR_MODE === 'true',
    dataRetentionDays: parseInt(import.meta.env.VITE_DATA_RETENTION_DAYS || '2555', 10),
  },
  rateLimit: {
    enabled: import.meta.env.VITE_RATE_LIMIT_ENABLED === 'true',
    maxRequestsPerMinute: parseInt(import.meta.env.VITE_MAX_REQUESTS_PER_MINUTE || '100', 10),
  },
  notifications: {
    sms: import.meta.env.VITE_SMS_ENABLED === 'true',
    email: import.meta.env.VITE_EMAIL_ENABLED === 'true',
    push: import.meta.env.VITE_PUSH_NOTIFICATIONS_ENABLED === 'true',
  },
  cache: {
    enabled: import.meta.env.VITE_CACHE_ENABLED === 'true',
    ttl: parseInt(import.meta.env.VITE_CACHE_TTL || '3600', 10),
  },
  demo: {
    enabled: import.meta.env.VITE_DEMO_MODE === 'true',
  },
  debug: {
    enabled: import.meta.env.VITE_DEBUG_MODE === 'true',
    sourceMaps: import.meta.env.VITE_SOURCE_MAPS === 'true',
    mockApi: import.meta.env.VITE_MOCK_API === 'true',
  },
} as const

export type Config = typeof config

export function isProduction(): boolean {
  return config.app.env === 'production'
}

export function isStaging(): boolean {
  return config.app.env === 'staging'
}

export function isDevelopment(): boolean {
  return config.app.env === 'development'
}

export function isFeatureEnabled(feature: keyof typeof config.features): boolean {
  return config.features[feature]
}
